import FiltersController from 'JS/classes/FiltersController';

class ProductFilter {

    type = 'desktop';

    constructor(filter) {
        if (!filter) {
            return;
        }
        
        this.filter = filter;
        this.filterBtns = this.filter.querySelectorAll('[data-filter]');
        this.closeBtn = this.filter.querySelector('.product-filter__controller-close');
        this.filterWrap = this.filter.querySelector('.product-filter__wrap');
        this.dataAttr = undefined;
        this.btnClass = 'product-filter__controller-';
        this.contentClass = 'product-filter__';
        this.activeContent = undefined;

        this.overlay = this.filter.querySelector('.product-filter__overlay');
        this.catsBtn = this.filter.querySelector('[data-filter="cats"]');
        this.init();

        window.productFilters = this;

        const controller = new FiltersController(this.filter, this);

        controller.filtersForm.on('change', () => {
            this.onCatChange(controller.filtersForm);
        });

        this.controller = controller;
    }

    onCatChange(filtersForm) {
        const chosenEl = filtersForm.fields.find(f => f.name === 'product_cat');

        if (!chosenEl && !chosenEl.inputElements.length) {
            return;
        }

        const chosenInput = chosenEl.inputElements.find(el => el.checked);

        if (!chosenInput) {
            return;
        }

        const textEl = chosenInput.closest('.product-filter__cats-item').querySelector('.product-filter__cats-item-text');

        if (!textEl) {
            return;
        }

        const buttonTextEl = this.catsBtn.querySelector('[data-category-text]');
        buttonTextEl.innerHTML = textEl.textContent;
    }

    init() {
        this.addListeners();
    }

    addListeners() {
        this.filterBtns.forEach(el => {
            el.addEventListener('click', () => {
                this.openFilters(el);
            });
        });

        [this.closeBtn, this.overlay].forEach(btn => {
            btn.addEventListener('click', () => {
                this.closeFilters();
            });
        });

        this.applySticky();

        window.addEventListener('scroll', () => {
            requestAnimationFrame(() => {
                this.applySticky();
            });
        });

        window.addEventListener('resize', () => {
            requestAnimationFrame(() => {
                this.changeOuterHeight();
            });
        });
    }

    changeOuterHeight() {
        if (!this.outer) {
            return;
        }
        if (window.innerWidth < 768) {
            return;
        }
        this.outer.style.height = `${this.filter.getBoundingClientRect().height}px`;
    }

    applySticky() {
        if (window.innerWidth < 768) {
            return;
        }

        if (!this.outer) {
            const wrap = (el, wrapper) => {
                el.parentNode.insertBefore(wrapper, el);
                wrapper.appendChild(el);
            };

            this.outer = document.createElement('div');
            
            wrap(this.filter, this.outer);

            Object.assign(this.outer.style, {
                'position': 'relative',
                'height': `${this.filter.getBoundingClientRect().height}px`,
            });

            Object.assign(this.filter.style, {
                'position': 'absolute',
                'top': '0',
                'left': '0',
                'width': '100%',
            });
        }

        const headerContent = document.querySelector('.header__content');

        let top = [headerContent].reduce((prev, current) => {
            return prev + (current.clientHeight ? current?.clientHeight : 0);
        }, -1);

        if (document.querySelector('body').classList.contains('admin-bar')) {
            top += 32;
        }

        const elTop = this.outer.getBoundingClientRect().top;

        if (elTop < top) {
            Object.assign(this.filter.style, {
                'position': 'fixed',
                'top': `calc(${top}px + 0.3rem)`,
                'left': window.innerWidth > 1920 ? 'calc((100vw - 1920px) * 0.5 + var(--main-padding))' : 'var(--main-padding)',
                'width': '100%',
            });
        } else {
            Object.assign(this.filter.style, {
                'position': 'absolute',
                'top': '0',
                'left': '0',
            });
            this.filter.style.removeProperty('width');
        }
    }

    openFilters(el) {
        el.classList.toggle('active');

        //закрываем врапер
        if (Array.from(this.filterBtns).every((el) => !el.classList.contains('active'))) {
            this.filterWrap.classList.remove('product-filter__wrap--open');
            this.closeBtn.classList.remove('product-filter__controller-close--open');
        }

        //открываем врапер
        if (!this.filterWrap.classList.contains('product-filter__wrap--open') && Array.from(this.filterBtns).some((el) => el.classList.contains('active'))) {
            this.filterWrap.classList.add('product-filter__wrap--open');
            this.closeBtn.classList.add('product-filter__controller-close--open');
        }

        this.dataAttr = el.dataset.filter;
        this.activeContent = this.filter.querySelector(`[data-content='${this.dataAttr}']`);
        this.activeContent.classList.toggle(`${this.contentClass}${this.dataAttr}--open`);
    }

    closeFilters() {
        this.filterWrap.classList.remove('product-filter__wrap--open');
        this.filterBtns.forEach(el => {
            el.classList.remove('active');
        });
        this.dataAttr = undefined;
        this.activeContent = undefined;
        this.closeBtn.classList.remove('product-filter__controller-close--open');
        this.filter.querySelectorAll(`[data-content]`).forEach(el => {
            if (el.dataset.content === 'cats') {
                el.classList.remove('product-filter__cats--open');
            }

            if (el.dataset.content === 'filters') {
                el.classList.remove('product-filter__filters--open');
            }
        });
    }
};

const productFilter = document.querySelector('.product-filter');
window.productFilters = new ProductFilter(productFilter);